import { createNoopInjectionToken } from 'ngxtension/create-injection-token';

export const [injectAppVersion, provideAppVersion] =
  createNoopInjectionToken<string>('App Version');
